import _ from '@lodash';
import TaskManagerResultOptimize from './TaskManagerResultOptimize';

function TaskManagerResultFit(props) {
	return <TaskManagerResultOptimize item={props.item} title="Fit result" onClose={props.onClose} />;
}

export default TaskManagerResultFit;
